import { Icon, Icons } from '@silverfort/sf-components';
import React, { FC } from 'react';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';

const RISK_LEVEL_TO_COLOR = {
    [RISK_LEVELS.HIGH.value]: 'sf-negative-500',
    [RISK_LEVELS.MEDIUM.value]: 'sf-warning-default',
    [RISK_LEVELS.LOW.value]: 'sf-warning-press',
    [RISK_LEVELS.CRITICAL.value]: 'sf-negative-500'
};

const getRiskLevelText = (riskLevel?: number) => {
    return Object.values(RISK_LEVELS).find((level) => level.value === riskLevel)?.label ?? 'no risk level found';
};

interface Props {
    riskLevel?: number;
}

const RiskLevelColumn: FC<Props> = ({ riskLevel }) => {
    const color = RISK_LEVEL_TO_COLOR[riskLevel ?? RISK_LEVELS.CRITICAL.value] ?? 'sf-negative-500';
    const riskLabel = getRiskLevelText(riskLevel);

    return (
        <div className="flex gap-1 items-center px-2 h-6 rounded border w-22">
            <Icon icon={Icons.Warning} className={`text-${color}`} size={16} />
            <div className="text-12 text-sf-gray-800 font-sf">{riskLabel}</div>
        </div>
    );
};

export default RiskLevelColumn;
